

import { Component, OnInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Table } from 'primeng/table';

import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { IDefaultLessDataGD } from '../models/defaultGD';
import { IDataRmOperadores } from '../models/rendimientoOperadores';
import { RendimientoOperadoresService } from '../services/rendimientoOperadores.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ISemanasHappyMile } from '../models/semanas';
import { SemanaService } from '../services/semana.service';
import { BonoRendimientoservice } from '../services/bonorendimiento.service';
import { IBonoRendimientoCombustible } from '../models/bonorendimientocombustible';
import { CiudadhmService } from '../services/ciudadhm.service';
import { ICiudadHM } from '../models/ciudadhm';
import { ConfunidadService } from '../services/confunidad.service';
import { IConfiguracionUnidad } from '../models/confUnidad';
import ICredencialUsuario from '../models/credencial';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';
import * as saveAs from 'file-saver';
@Component({
  selector: 'app-bonorendimiento',
  templateUrl: './bonorendimiento.component.html',
  styleUrls: ['./bonorendimiento.component.scss']
})
export class BonorendimientoComponent implements OnInit {
  isMobile: boolean = false;
  @ViewChild('dt1') dt!: Table;
  @ViewChild('dt2') dt2!: Table;
  months: IDefaultLessDataGD[] = [];
  selectMonth: number = 0;
  year: IDefaultLessDataGD[] = [];
  selectYear: any;
  selectYear_filtro: any;
  city: IDefaultLessDataGD[] = [];
  selectCity: number = 0;
  unitconf: IDefaultLessDataGD[] = [];
  selectConf: number = 0;
  lstConfUnidad: IConfiguracionUnidad[] = [];
  urlGeneral = '';
  urlOperators = '';

  dataOk: Boolean = false;
  anio_filtro: any;
  lstSemanas: ISemanasHappyMile[] = [];

  // lsResInfo: IDefaultDataRmOp = {};
  // lsRmOper: IDataRmOperadores[] = [];
  // lsRmOpRut: IDataRmOpServicios[] = [];
  lstBonoRendimientoCombustible: IBonoRendimientoCombustible[] = [];
  loading: boolean = false;
  loadingg: boolean = false;
  selectedSemana: ISemanasHappyMile = {
    idx: 0,
    id_semana: 0,
    nom_semana: '',
    anio: 0,
    fec_inicio: '',
    fec_fin: '',
    clv_activo: 0
  };
  lstFiltrados: IBonoRendimientoCombustible[] = [];
  dspaprobarindividual: boolean = false
  colaborador: any = ''
  importe: any = 0
  num_semana: number = 0;
  clv_activo: boolean = false;
  clv_rechazar: boolean = false;
  seleccionarTodo: boolean = false;
  dsprechazar: boolean = false;
  respuesta: string = ''
  dsprechazarmasivo: boolean = false
  user: ICredencialUsuario = {};
  choferSeleccionado: any;

  reactiveaprovechamiento: FormGroup = new FormGroup({
    cod_chofer: new FormControl(0),
    nom_operador: new FormControl(''),
    num_mes: new FormControl(0),
    num_anio: new FormControl(0),
    num_mes_bono: new FormControl(0),
    num_anio_bono: new FormControl(0),
    id_semana_PAGAR: new FormControl(0),
    imp_bono: new FormControl(0),
    clv_bono: new FormControl(0),
    comentario: new FormControl(''),
    cod_usuario: new FormControl(''),
    clave_confUnidad: new FormControl(0),


  });
  reactive: FormGroup = new FormGroup({
    comentario: new FormControl(''), });


  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private rendimientoOperadores: RendimientoOperadoresService,
    private semanaService: SemanaService,
    private bonorendimiento: BonoRendimientoservice,
    private CiudadhmService: CiudadhmService,
    private confunidadService: ConfunidadService,
    private auth: AuthService,
    private cdRef: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.months = [
      { id: 1, nombre: 'ENERO' },
      { id: 2, nombre: 'FEBRERO' },
      { id: 3, nombre: 'MARZO' },
      { id: 4, nombre: 'ABRIL' },
      { id: 5, nombre: 'MAYO' },
      { id: 6, nombre: 'JUNIO' },
      { id: 7, nombre: 'JULIO' },
      { id: 8, nombre: 'AGOSTO' },
      { id: 9, nombre: 'SEPTIEMBRE' },
      { id: 10, nombre: 'OCTUBRE' },
      { id: 11, nombre: 'NOVIEMBRE' },
      { id: 12, nombre: 'DICIEMBRE' },
    ];

    //this.getCityAndConfUnitInformacion()
    this.inicializarFechas();
    this.cargarListadoDeSemanasAnio_cast(new Date().toLocaleDateString('es-MX', { year: 'numeric' })),
      this.checkScreenSize();
    this.selectYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    this.anio_filtro = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    this.cargarCiudades();
    this.cargarListadoDeConfUnidad();
    this.cargarInformacionUsuario();
  }

  inicializarFechas() {
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    // this.anio = getYear;
    this.anio_filtro = getYear;
  }


  lstCiudad: ICiudadHM[] = [];

  cargarCiudades() {
    this.loading = true;
    this.CiudadhmService.getListadoCiudades().subscribe((resp) => {
      this.lstCiudad = resp
      setTimeout(() => {
        this.loading = false;

      }, 300);
    },
      (error) => {
        this.loading = false;
        this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Listado de Ciudades');
      });
  }
  cargarInformacionUsuario() {
    this.user = this.auth.user;
  }

  cargarListadoDeConfUnidad() {
    this.confunidadService.getListadoConfUnidades().subscribe((resp) => {
      this.lstConfUnidad = resp;
    }, (error) => {
      this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error en <Listar Conf.Unidad>', detail: 'Contacte al Administrador del Sitio' });
    });
  }


  getTargetDescription(ruta: ISemanasHappyMile) {
    let fec_inicio = new Date(ruta.fec_inicio);
    let fec_fin = new Date(ruta.fec_fin);
    return this.formatearFechas(fec_inicio) + ' | ' + this.formatearFechas(fec_fin);
  }
  formatearFechas(fecha: Date): string {
    let fecha_Cast = '';
    var getYear = new Date(fecha).toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date(fecha).toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date(fecha).toLocaleDateString('es-MX', { day: '2-digit' });
    fecha_Cast = getDay + '/' + getMonth + '/' + getYear;
    return fecha_Cast;
  }

  searchUnitAction() {
    const anio_cast = this.selectYear instanceof Date ? this.selectYear.getFullYear() : this.selectYear;

    if (this.selectMonth == 0 || this.selectMonth == null || anio_cast == '' || anio_cast == null || this.selectCity == 0 || this.selectCity == null || this.selectConf == 0 || this.selectConf == null) {
      (document.getElementById('button_search_unit') as HTMLButtonElement).disabled = false
      this.messageService.add({ severity: 'warn', summary: 'Campos incorrectos', detail: 'Debes seleccionar una configuracion valida.' });
    } else {


      this.getResumenRendimientoOperadores(this.selectMonth, anio_cast, this.selectCity, this.selectConf)
    }
  }

  getResumenRendimientoOperadores(month: number, year: number, city: number, conf: number) {
    const anio_cast = this.selectYear instanceof Date ? this.selectYear.getFullYear() : this.selectYear;

    this.loading = true;
    this.bonorendimiento.getbono(month, year, city, conf).subscribe((resp) => {
      this.lstBonoRendimientoCombustible = resp
      this.loading = false;
      if (resp) {
        if (typeof this.lstBonoRendimientoCombustible === null) {
          this.loading = false;
          this.clearData();
          this.messageService.add({ severity: 'info', summary: 'No hay informacion', detail: 'No cuenta con informacion esta configuracion.' });
        }
      }
    },
      (error) => {
        this.loading = false;
        this.clearData();
        this.mostrarDialogoInformativoSinInformacion('<b>Error</b> Al cargar el listado de herramientas seleccionadas de la unidad');
      });

  }



  hideServResume() {
    const moduleMain = document.getElementById('module_main_rmop')
    const moduleOperator = document.getElementById('module_operator_rmop')

    if (moduleMain && moduleOperator) {
      moduleMain.style.display = "block";
      moduleOperator.style.display = "none";
    }
  }

  mostrarDialogoInformativoSinInformacion(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '. <b>Verifique la informacion.</b>';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      key: "sinInformacionDialog"
    });
  }

  validateUrl(event: Event) {
    if (this.urlGeneral == '' || this.urlOperators == '') {
      event.preventDefault();
      alert('Debes buscar una ruta valida')
    }
  }

  applyFilterGlobal($event: any, stringVal: any) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }
  applyFilterGlobal2($event: any, stringVal: any) {
    this.dt2.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }
  formatCurrency(number: any) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(number);
  }

  formatNumber(number: any) {
    return new Intl.NumberFormat('en-US').format(number);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth < 768;
  }

  clearData() {
    this.urlGeneral = '';
    this.urlOperators = '';
    this.dataOk = false;

    this.loading = false;
  }
  dbspagar: boolean = false



  cancelarModalAprobar() {
    this.clv_rechazar = false;
    this.dbspagar = false;
    this.dsprechazarmasivo=false;
    this.seleccionarTodo=false;
    this.selectedSemana = {
      idx: 0,
      id_semana: 0,
      nom_semana: '',
      anio: 0,
      fec_inicio: '',
      fec_fin: '',
      clv_activo: 0
    }
  }

  Aprobar() {
    this.lstFiltrados = this.lstBonoRendimientoCombustible.filter(c =>
      c.num_diferencia !== undefined &&
      Number(c.num_diferencia) > 0 &&
      c.bonus_ok === 'SI' && c.clv_bono == 0
    );

    this.lstFiltrados = this.lstFiltrados.map(item => ({
      ...item,
      clv_activo: item.clv_bono === 1,
      clv_rechazar: item.clv_bono === 2
    }));

    this.dbspagar = true;
  }


  cargarListadoDeSemanasAnio_cast(anio_filtro: any) {

    this.loadingg = true;
    let anio_cast: any = 0;
    if (anio_filtro instanceof Date) {
      // will execute
      anio_cast = anio_filtro.getFullYear();
    } else {
      anio_cast = anio_filtro;
    }
    this.lstSemanas = [];

    this.semanaService.listarSemanas(anio_cast).subscribe((resp) => {
      this.lstSemanas = resp;
      setTimeout(() => {
        this.loadingg = false
      },
        600);
    },
      (error) => {
        this.loadingg = false
        this.mostrarDialogoInformativoSinInformacion('<b>Error al cargar Semanas HM</b>.');
      });
  }


  toggleSeleccionarTodo() {
    this.lstFiltrados.forEach(item => {
      if (!item.clv_rechazar) {
        item.clv_activo = this.seleccionarTodo;
        item.clv_activo ? item.clv_bono = 1 : item.clv_bono = 0

      }
    });
  }


  //carga masiva
  guardartodo() {
    let mes = this.months.find(x=> x.id  == this.selectMonth)
    const anio_cast = this.selectYear instanceof Date ? this.selectYear.getFullYear() : this.selectYear;
if(this.selectedSemana.id_semana === 0 ){
  this.messageService.add({ key: 'msj', severity: 'info', summary: 'Advertencia', detail: 'Error al guardar la lista. Es necesario seleccionar una semana para guardar'});

}else{

    const data_enviar = this.lstFiltrados
      .filter(item => item.clv_bono !== 0)
      .map(item => ({
        cod_chofer: item.cod_chofer,
        nom_operador: item.nom_operador,
        id_ciudad_hm: this.selectCity,
        num_mes: item.num_mes,
        num_anio: item.num_anio,
        num_anio_bono: this.selectedSemana.anio,
        id_semana_PAGAR: this.selectedSemana.id_semana,
        imp_bono: item.bono,
        clv_bono: item.clv_bono,
        comentario: item.comentario || '',
        cod_usuario: this.user?.cod || '0999',
        clave_confUnidad: item.clave_confUnidad,
        clv_masivo: 1
      }));

      if (data_enviar.length === 0) {
        this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Advertencia',detail: 'No hay registros válidos para guardar.' });
        return;
      }


    this.confirmationService.confirm({
      message: '¿Está seguro de guardar todos los registros modificados correspondientes al mes de <b>'
      +mes?.nombre+' </b>del año <b>'+this.selectYear+
      '</b> en la semana <b>'+this.selectedSemana.id_semana +'</b>?',
      header: 'Confirmación de Aprobación Masiva de Bonos',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.bonorendimiento.postbonoRendimientoMasivo(data_enviar).subscribe(resp => {
          if (resp.clv_estatus === 1) {
            this.messageService.add({ key: 'msj', severity: 'success', summary: 'Éxito', detail: 'Lista guardada correctamente' });
            this.close();
            this.cancelarModalAprobar();
            this.getResumenRendimientoOperadores(this.selectMonth, anio_cast, this.selectCity, this.selectConf);
          } else {
            this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: resp.messageDetails || 'Error al guardar la lista' });
          }
        });
      }
    });
  }
  }




  // rechar los foliso d emanera masiva
  rechazarmasivo(data: IBonoRendimientoCombustible) {
    this.choferSeleccionado = data;
    if( data.clv_rechazar == true){
      this.dsprechazarmasivo = true;
    }

    this.colaborador = data.nom_operador;
    this.importe = data.bono
    this.reactiveaprovechamiento.controls['cod_chofer'].setValue(data.cod_chofer)
    this.reactiveaprovechamiento.controls['nom_operador'].setValue(data.nom_operador)
    this.reactiveaprovechamiento.controls['num_mes'].setValue(data.num_mes)
    this.reactiveaprovechamiento.controls['num_anio'].setValue(data.num_anio)
    this.reactiveaprovechamiento.controls['imp_bono'].setValue(data.bono)
    this.reactiveaprovechamiento.controls['clave_confUnidad'].setValue(data.clave_confUnidad)
    data.clv_rechazar = true;

  }

  rechazarguardarlista() {
    // Buscar el índice del objeto que coincide con choferSeleccionado
    const index = this.lstFiltrados.findIndex(
      item => item.cod_chofer === this.choferSeleccionado.cod_chofer
    );

    if (index !== -1) {
      // Modificar directamente en la lista
      this.lstFiltrados[index] = {
        ...this.lstFiltrados[index],
        clv_bono: 2,
        comentario: this.respuesta || '',
        clv_rechazar: true
      };
    }
    this.reactiveaprovechamiento.controls['clv_bono'].setValue(2)
    this.close();
    this.lstFiltrados = [...this.lstFiltrados]; // Forzar cambio de referencia
    this.cdRef.detectChanges(); // Forzar cambio visual si necesario

  }


  aprobarmarivoindividual(data: IBonoRendimientoCombustible) {


    const index = this.lstFiltrados.findIndex(
      item => item.cod_chofer === data.cod_chofer
    );

    if (index !== -1) {
      // Modificar directamente en la lista
      this.lstFiltrados[index] = {
        ...this.lstFiltrados[index],
        clv_bono: 1,

        comentario: this.respuesta || '',
        clv_activo: true

      };
      this.reactiveaprovechamiento.controls['clv_bono'].setValue(1)
    }

    this.lstFiltrados = [...this.lstFiltrados]; // Forzar cambio de referencia
    this.cdRef.detectChanges(); // Forzar cambio visual si necesario

    this.reactiveaprovechamiento.controls['cod_chofer'].setValue(data.cod_chofer)
    this.reactiveaprovechamiento.controls['nom_operador'].setValue(data.nom_operador)
    this.reactiveaprovechamiento.controls['num_mes'].setValue(data.num_mes)
    this.reactiveaprovechamiento.controls['num_anio'].setValue(data.num_anio)
    this.reactiveaprovechamiento.controls['imp_bono'].setValue(data.bono)
    this.reactiveaprovechamiento.controls['clave_confUnidad'].setValue(data.clave_confUnidad)


  }





  rechazar(data: IBonoRendimientoCombustible) {

    this.dsprechazar = true;
    data.clv_activo = false;
    this.colaborador = data.nom_operador;
    this.importe = data.bono
    this.reactiveaprovechamiento.controls['cod_chofer'].setValue(data.cod_chofer)
    this.reactiveaprovechamiento.controls['nom_operador'].setValue(data.nom_operador)
    this.reactiveaprovechamiento.controls['num_mes'].setValue(data.num_mes)
    this.reactiveaprovechamiento.controls['num_anio'].setValue(data.num_anio)
    this.reactiveaprovechamiento.controls['imp_bono'].setValue(data.bono)
    this.reactiveaprovechamiento.controls['clave_confUnidad'].setValue(data.clave_confUnidad)


  }


  close() {
    this.dsprechazarmasivo = false;
    this.respuesta = ''
    this.clv_rechazar = false;
    this.dsprechazar =false;
    //
    this.selectedSemana = {
      idx: 0,
      id_semana: 0,
      nom_semana: '',
      anio: 0,
      fec_inicio: '',
      fec_fin: '',
      clv_activo: 0
    }
  }


  cancelarrechazar() {
    this.dsprechazar = false;
    this.respuesta=''
    this.selectedSemana = {
      idx: 0,
      id_semana: 0,
      nom_semana: '',
      anio: 0,
      fec_inicio: '',
      fec_fin: '',
      clv_activo: 0
    }

  }

  cancelarrechazarmasivoindi() {
    this.dsprechazarmasivo = false;
    this.choferSeleccionado.clv_rechazar = false;
    this.choferSeleccionado.comentario = '';
    // this.respuesta=''
  }
  rechazarguardar() {
    this.clv_rechazar = !this.clv_rechazar;
    this.reactiveaprovechamiento.controls['clv_bono'].setValue(2)
    this.reactiveaprovechamiento.controls['comentario'].setValue(this.respuesta)
  }


  //rechazar
  rechazarguardarindividual() {
    if (this.selectedSemana.id_semana == 0 || this.selectedSemana.id_semana == null || this.respuesta == '' || this.respuesta == null ) {
      this.messageService.add({ severity: 'warn', summary: 'Campos incorrectos', detail: 'Debes seleccionar todos los parametros solicitados.' });
    } else{
    let mes = this.months.find(x=> x.id  == this.selectMonth)
    const anio_cast = this.selectYear instanceof Date ? this.selectYear.getFullYear() : this.selectYear;

      let data_enviar = {
        cod_chofer: this.reactiveaprovechamiento.controls['cod_chofer'].value,
        nom_operador: this.reactiveaprovechamiento.controls['nom_operador'].value,
        id_ciudad_hm: this.selectCity,
        num_mes: this.reactiveaprovechamiento.controls['num_mes'].value,
        num_anio: this.reactiveaprovechamiento.controls['num_anio'].value,
        //  num_mes_bono : this.selectedSemana.,
        num_anio_bono: this.selectedSemana.anio,
        id_semana_PAGAR: this.selectedSemana.id_semana,
        imp_bono: this.reactiveaprovechamiento.controls['imp_bono'].value,
        clv_bono: 2,
        comentario: this.respuesta,
        cod_usuario: this.user.cod == undefined ? '0999' : this.user.cod,
        clave_confUnidad: this.reactiveaprovechamiento.controls['clave_confUnidad'].value,
        clv_masivo: 0
      }
      this.confirmationService.confirm({
        message: '¿Está seguro de <b>RECHAZAR</b> el <b>BONO POR RENDIMIENTO DE COMBUSTIBLE </b>  del Colaborador <b>' +
        this.reactiveaprovechamiento.controls['nom_operador'].value + ' </b>correspondiente al mes de <b>'+mes?.nombre+' </b>del año <b>'
        +this.reactiveaprovechamiento.controls['num_anio'].value+'</b> en la semana <b>'+this.selectedSemana.id_semana +'</b>?',
        header: 'Confirmación de Rechazo de Bono',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.bonorendimiento.postbonoRendimientoIndividual(data_enviar).subscribe((resp) => {
            if (resp.clv_estatus == 1) {
              this.messageService.add({ key: 'msj', severity: 'success', summary: 'Exito', detail: 'Se Rechazo correctamente' });
              this.dspaprobarindividual = false;
              this.close();
              this.getResumenRendimientoOperadores(this.selectMonth, anio_cast, this.selectCity, this.selectConf);

            } else if (resp.clv_estatus == 2) { this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'El colaborador ya fue recomendado anteriormente' }); }
            else if (resp.clv_estatus == -2) {
              this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: resp.messageDetails });
              this.close();
            }
          });
        },
        reject: (type: any) => {
          switch (type) {
            case ConfirmEventType.REJECT:
              this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operación cancelada' });
              this.close();
              break;
            case ConfirmEventType.CANCEL:
              this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operación cancelada' });
              this.close();
              break;

          }
        }
      });}
  }


  aprobarindividual(data: IBonoRendimientoCombustible) {
    this.dspaprobarindividual = true;
    this.colaborador = data.nom_operador;
    this.importe = data.bono
    this.reactiveaprovechamiento.controls['cod_chofer'].setValue(data.cod_chofer)
    this.reactiveaprovechamiento.controls['nom_operador'].setValue(data.nom_operador)
    this.reactiveaprovechamiento.controls['num_mes'].setValue(data.num_mes)
    this.reactiveaprovechamiento.controls['num_anio'].setValue(data.num_anio)
    this.reactiveaprovechamiento.controls['imp_bono'].setValue(data.bono)
    this.reactiveaprovechamiento.controls['clave_confUnidad'].setValue(data.clave_confUnidad)

  }



  guardarindividual() {
    if (this.selectedSemana.id_semana == 0 || this.selectedSemana.id_semana == null ) {

      this.messageService.add({ severity: 'warn', summary: 'Campos incorrectos', detail: 'Debes seleccionar todos los parametros solicitados.' });

    } else{
    let mes = this.months.find(x=> x.id  == this.selectMonth)
    const anio_cast = this.selectYear instanceof Date ? this.selectYear.getFullYear() : this.selectYear;
      let data_enviar = {
        cod_chofer: this.reactiveaprovechamiento.controls['cod_chofer'].value,
        nom_operador: this.reactiveaprovechamiento.controls['nom_operador'].value,
        id_ciudad_hm: this.selectCity,
        num_mes: this.reactiveaprovechamiento.controls['num_mes'].value,
        num_anio: this.reactiveaprovechamiento.controls['num_anio'].value,
        num_anio_bono: this.selectedSemana.anio,
        id_semana_PAGAR: this.selectedSemana.id_semana,
        imp_bono: this.reactiveaprovechamiento.controls['imp_bono'].value,
        clv_bono: 1,
        comentario: this.respuesta,
        cod_usuario: this.user.cod == undefined ? '0999' : this.user.cod,
        clave_confUnidad: this.reactiveaprovechamiento.controls['clave_confUnidad'].value,
        clv_masivo:0
      }

      this.confirmationService.confirm({
        message: '¿Está seguro de <b>APROBAR</b> el <b>BONO POR RENDIMIENTO DE COMBUSTIBLE </b>  del Colaborador <b>' +
        this.reactiveaprovechamiento.controls['nom_operador'].value + ' </b>correspondiente al mes de <b>'+mes?.nombre+' </b>del año <b>'+this.reactiveaprovechamiento.controls['num_anio'].value+
        '</b> en la semana <b>'+this.selectedSemana.id_semana +'</b>?',
        header: 'Confirmación de Aprobación de Bono',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.bonorendimiento.postbonoRendimientoIndividual(data_enviar).subscribe((resp) => {
            if (resp.clv_estatus == 1) {
              this.messageService.add({ key: 'msj', severity: 'success', summary: 'Exito', detail: 'Se aprobo correctamente' });
              this.dspaprobarindividual = false;
              this.getResumenRendimientoOperadores(this.selectMonth, anio_cast, this.selectCity, this.selectConf);
            } else if (resp.clv_estatus == 2) { this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'El colaborador ya fue recomendado anteriormente' }); }
            else if (resp.clv_estatus == -2) {
              this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: resp.messageDetails });
            }
          });
        },
        reject: (type: any) => {
          switch (type) {
            case ConfirmEventType.REJECT:
              this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operación cancelada' });
              break;
            case ConfirmEventType.CANCEL:
              this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operación cancelada' });
              break;
          }
        }
      });
    }
  }


  cancelaraprobarindividual() {
    this.dspaprobarindividual = false;
    this.colaborador = ''
    this.selectedSemana = {
      idx: 0,
      id_semana: 0,
      nom_semana: '',
      anio: 0,
      fec_inicio: '',
      fec_fin: '',
      clv_activo: 0
    }
  }

  eliminar(data: IBonoRendimientoCombustible) {
    const anio_cast = this.selectYear instanceof Date ? this.selectYear.getFullYear() : this.selectYear;

    const data_enviar = {
      cod_chofer: data.cod_chofer,
      id_ciudad_hm: this.selectCity,
      num_mes: data.num_mes,
      num_anio: data.num_anio,
    };

    if (data.clv_bono == 1 || data.clv_bono == 2) {
      this.confirmationService.confirm({
        message: '¿Está seguro de Eliminar el registro de <b>BONO POR RENDIMIENTO DE COMBUSTIBLE</b> del Colaborador <b>' +
          data.nom_operador + '</b>?',
          header: 'Confirmación de Eliminación de Registro',
          icon: 'pi pi-info-circle',
        accept: () => {
          this.bonorendimiento.eliminarbono(data_enviar).subscribe((resp) => {
            if (resp.clv_estatus == 1) {
              this.messageService.add({ key: 'msj', severity: 'success', summary: 'Exito', detail: 'Se Elimino correctamente' });
              this.dspaprobarindividual = false;
              this.getResumenRendimientoOperadores(this.selectMonth, anio_cast, this.selectCity, this.selectConf);
            } else if (resp.clv_estatus == -2) {
              this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: resp.messageDetails });
            }
          });
        },
        reject: (type: any) => {
          switch (type) {
            case ConfirmEventType.REJECT:
            case ConfirmEventType.CANCEL:
              this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operación cancelada'});
              break;
          }
        }
      });
    }
  }
  dspVerMas:boolean =false
  chofer:string=''
  vermas(data:IBonoRendimientoCombustible){
    this.dspVerMas=true;
    this.reactive.controls['comentario'].setValue(data.comentario)
    this.reactive.controls['comentario'].disable()
this.chofer =data.nom_operador
  }
  verMenos(){
    this.dspVerMas=false;
    this.chofer=''
    this.reactive.reset()
  }

  limpiar(){
    this.lstBonoRendimientoCombustible=[];
  }

  deshabilitarbtnexportar:boolean=false;
  exportarExcel() {

    this.deshabilitarbtnexportar = true;
    this.loading = true;
    let ciudad = this.lstCiudad.find(ciudad => ciudad.id == this.selectCity)
    const anio_cast = this.selectYear instanceof Date ? this.selectYear.getFullYear() : this.selectYear;
    let mes = this.months.find(x=> x.id  == this.selectMonth)

    if (this.selectMonth == 0 || this.selectMonth == null || anio_cast == '' || anio_cast == null || this.selectCity == 0 || this.selectCity == null || this.selectConf == 0 || this.selectConf == null) {

      this.messageService.add({ severity: 'warn', summary: 'Campos incorrectos', detail: 'Debes seleccionar todos los parametros solicitados.' });
      this.deshabilitarbtnexportar = false;
      this.loading = false;
    } else {


      this.bonorendimiento.rptbono(this.selectMonth, anio_cast, this.selectCity ,this.selectConf )
        .subscribe((resp: any[]) => {
          if (resp.length === 0 || typeof resp === 'undefined') {
            this.mostrarDialogoInformativoSinInformacion('<b>Aviso</b> debes de seleccionar parametros validos con registros existentes para poder exportar la informacion del Catalogo(Excel)');

            this.deshabilitarbtnexportar = false;
            this.loading = false;
          } else {
            import("xlsx").then(xlsx => {
              const worksheet = xlsx.utils.json_to_sheet(resp);
              const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
              const excelBuffer: any = xlsx.write(workbook, {
                bookType: "xlsx",
                type: "array"
              });
              // Reporte_salario_promedio_monterreytp_semana_48_año_2024_exportar_2024-12-06.xlsx

              this.saveAsExcelFile(excelBuffer, "Reporte_bono_rendimiento_combustible" + '_'+ciudad?.nombre+'_'+mes?.nombre + '_' + anio_cast);
            });
            setTimeout(() => {
              // this.ButtonExportExcel = false;
              this.deshabilitarbtnexportar = false;
              this.loading = false;
             // this.cancelarModalReportes()
            }, 1000);
          }
        },
          (error) => {
            // this.ButtonExportExcel = false;
            // this.deshabilitarbtnexportar = false;

            this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'Error en emitir el reporte de Estatus de Facturación.' });
          });
      //}

    }
  }

    saveAsExcelFile(buffer: any, fileName: string): void {
      var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
      var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
      var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
      var dateFormat = getYear + "-" + getMonth + "-" + getDay;
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(data, fileName + "_exportar_" + dateFormat + EXCEL_EXTENSION);
    }


}




